import styled from 'styled-components';
import ControlWithLabel from '../../../cm/common/ControlWithLabel';

export const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.04em;
  color: #748aa1;
  /* FIN-11957: render labels (Alert Quality / Alert Score) in their authored
     title case. The prior FIN-11542 uppercase text-transform was reported as a
     bug and removed. */
  padding-left: 0.3em;
  margin-bottom: 7px;
`;

export const AlertScoreWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 3px;

  .ant-progress-line {
    width: auto;
    margin-right: 5px;
    margin-left: 3px;
  }

  .ant-progress-inner {
    width: 80px;

    .ant-progress-bg {
      height: 11px !important;
    }
  }

  p {
    margin: 2px 0 0;
    font-weight: 300;
    font-size: 9px;
    line-height: 16px;

    b {
      font-weight: bold;
      font-size: 12px;
    }
  }
`;

export const ProgressText = styled.div`
  font-size: 11px;
  padding: 0;
  margin: 0;
  color: #31394d;
  font-weight: 500;
`;

export const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SmartAssessHeaderPanel = styled.div`
  font-size: 16px;
  font-style: normal;
  color: #31394d;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  padding-top: 5px;
  padding-bottom: 12px;
`;

export const SelectBoxContainer = styled.div`
  font-weight: 400;
  min-width: 150px;
  background: #ffffff;
  border: 0px solid #d0d7e3;
  box-sizing: border-box;
  border-radius: 4px;
`;

export const StyledControlWithLabel = styled(ControlWithLabel)`
  font-size: 12px;
  font-weight: 700;
  margin-right: 24px;
`;

export const StyledCmControls = styled.div`
  display: flex;
  margin-top: 16px;
  margin-bottom: 24px;
`;

// FIN-11542 (Ganesh 2026-06-03): June-drop mock EVENT CONTEXT strip — a
// horizontal row above the cards. Carries the "EVENT CONTEXT" label +
// "Transaction · Activity" badge on the left and the pair-cycle arrows
// on the right. Replaces the old arrows-flanking-cards layout.
export const EventContextStrip = styled.div.attrs({
  className: 'event-context-strip'
})`
  // FIN-11962: label on the left, pair-cycle arrows on the right. The strip is
  // rendered inside the card-pair's flex-grow column (see SmartAssessmentTopPanel
  // index.js), so its right edge == the 2nd card's right edge — the arrows land
  // at the top-right corner of the Transaction Amount card, per Kiran's mock.
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0 8px 0;
  width: 100%;
`;

export const EventContextLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #748aa1;
  text-transform: uppercase;
`;

export const ContextBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  font-size: 11px;
  font-weight: 500;
  color: #31394d;
  background: #eef2f8;
  border: 1px solid #d0d7e3;
  border-radius: 12px;
  text-transform: none;
  letter-spacing: 0;
`;

export const ContextArrows = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const ArrowButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #d0d7e3;
  border-radius: 4px;
  background: #ffffff;
  color: #31394d;
  cursor: pointer;
  padding: 0;
  margin: 0 4px;

  &:disabled {
    color: #b0b8c4;
    cursor: not-allowed;
    background: #f5f7fa;
  }

  &:hover:not(:disabled) {
    background: #f0f4fa;
  }
`;
